var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "create-container" }, [
    _c(
      "div",
      { staticStyle: { "margin-bottom": "20px" } },
      [
        _c(
          "el-button",
          {
            attrs: { icon: "el-icon-back", size: "small", plain: "" },
            on: {
              click: function ($event) {
                return _vm.closeWindow(false)
              },
            },
          },
          [
            _vm._v(
              _vm._s(_vm.$t("userManage.ReturnListTemporaryWorkerAccounts"))
            ),
          ]
        ),
      ],
      1
    ),
    _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
      _c("div", { staticClass: "create-title" }, [
        _vm._v(_vm._s(_vm.$t("userManage.CreateTemporaryWorkerAccountsBulk"))),
      ]),
      _c("div", { staticStyle: { "font-size": "14px" } }, [
        _vm._v(
          _vm._s(_vm.$t("userManage.ImportAndCreateTemporaryWorkerAccounts"))
        ),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "steps-all" },
      [_c("steps", { attrs: { "active-steps": _vm.activeSteps } })],
      1
    ),
    _c(
      "div",
      [
        _vm.activeSteps === 1
          ? _c("uploadFile", {
              attrs: { "site-id-list": _vm.siteIdList },
              on: { submitUploadFile: _vm.submitUploadFile },
            })
          : _vm._e(),
        _vm.activeSteps === 2
          ? _c("verification", {
              key: _vm.verificationKey,
              attrs: {
                "site-id-list": _vm.siteIdList,
                "validate-data": _vm.validateData,
              },
              on: {
                createAccounts: _vm.createAccounts,
                submitUploadFile: _vm.submitUploadFile,
              },
            })
          : _vm._e(),
        _vm.activeSteps === 3
          ? _c("createdSuccess", {
              key: _vm.createDataKey,
              attrs: {
                "site-id-list": _vm.siteIdList,
                "create-data": _vm.createData,
              },
              on: { closeWindow: _vm.closeWindow },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }